import { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useDrawerContext } from '../shared/contexts';
import { DetalheDeCei, DetalheDeColhedores, ListagemDeAreas, ListagemDeCei, ListagemDeColhedores, ListagemDeFazendas, ListagemDeQuadra, ListagemUsuarios } from '../pages/cadastros';
import { DetalheUsuario } from '../pages/cadastros/usuarios/DetalheUsuario';
import { DetalheDeAdiantamento, GeraProducao, GeraProducaoIndividual, ListagemDeAdiantamentos, ListagemDeColheitas, Paginainicial, RelatorioColheita, RelatorioColheitaPorColhedor } from '../pages/movimentos';
import { ProducaoFazenda, RAdiantamento, Recibos } from '../pages/relatorios';



export const AppRoutes = () => {
  const {toggleDrawerOpen, setDrawerOptions, setDrawerItemOptions} = useDrawerContext();

  useEffect(()=>{
  
    setDrawerOptions([
      {
       label: 'Cadastro',
       icon: 'account_circle',
       path: '/cadastro',
      },
      {
        label: 'Movimentos',
        icon: 'app_registration',
        path: '/movimentos',
      },
      {
        label: 'Relatorios',
        icon: 'fact_check',
        path: '/relatorios',
       }
    ]);
    
    setDrawerItemOptions([
      {
        label: 'Fazenda',
        icon: 'waves',
        path: '/fazendas',
        parent: '/cadastro'
       },
       {
        label: 'CEI',
        icon: 'factory',
        path: '/cei',
        parent: '/cadastro'
       },
       {
        label: 'Area',
        icon: 'crop',
        path: '/areas',
        parent: '/cadastro'
       },
       {
        label: 'Quadra',
        icon: 'square',
        path: '/quadras',
        parent: '/cadastro'
       },
       {
        label: 'Colhedor',
        icon: 'person',
        path: '/colhedores',
        parent: '/cadastro'
       },
       {
        label: 'Usuário',
        icon: 'account_circle',
        path: '/usuarios',
        parent: '/cadastro'
       },
       {
        label: 'Gera Produção',
        icon: 'settings',
        path: '/gera',
        parent: '/movimentos'
       },
       {
        label: 'Gera Produção Individual',
        icon: 'engineering',
        path: '/geraindividual',
        parent: '/movimentos'
       },
       {
        label: 'Adiantamentos',
        icon: 'currency_exchange',
        path: '/adiantamentos',
        parent: '/movimentos'
       },
       {
        label: 'Colheitas',
        icon: 'camera_rear',
        path: '/colheitas',
        parent: '/movimentos'
       },
       {
        label: 'Colheita',
        icon: 'print',
        path: '/rcolheitas',
        parent: '/relatorios'
       },
       {
        label: 'Colheita por Colhedor',
        icon: 'print',
        path: '/rcolheitasporcolhedor',
        parent: '/relatorios'
       },
       {
        label: 'Produção Fazenda',
        icon: 'print',
        path: '/rproducaofazenda',
        parent: '/relatorios'
       },
       {
        label: 'Recibos',
        icon: 'print',
        path: '/recibos',
        parent: '/relatorios'
       },
       {
        label: 'Adiantamentos',
        icon: 'print',
        path: '/radiantamentos',
        parent: '/relatorios'
       },
    ]);
  },[]);

  return (
   <Routes>
    <Route path="/fazendas" element={<ListagemDeFazendas />} />
    <Route path="/cei" element={<ListagemDeCei />} />
    <Route path="/cei/detalhe/:id" element={<DetalheDeCei />} /> 
    <Route path="/areas" element={<ListagemDeAreas />} />
    <Route path="/quadras" element={<ListagemDeQuadra />} />
    <Route path="/colhedores" element={<ListagemDeColhedores />} />
    <Route path="/colhedores/detalhe/:id" element={<DetalheDeColhedores />} /> 
    <Route path="/usuarios" element={<ListagemUsuarios />} />
    <Route path="/usuarios/:id" element={<DetalheUsuario />} /> 
    <Route path="/adiantamentos" element={<ListagemDeAdiantamentos />} />
    <Route path="/adiantamentos/detalhe/:id" element={<DetalheDeAdiantamento />} /> 
    <Route path="/gera" element={<GeraProducao />} />
    <Route path="/geraindividual" element={<GeraProducaoIndividual />} />
    <Route path="/rproducaofazenda" element={<ProducaoFazenda />} />
    <Route path="/colheitas" element={<ListagemDeColheitas />} />   
    <Route path="/rcolheitas" element={<RelatorioColheita />} />
    <Route path="/rcolheitasporcolhedor" element={<RelatorioColheitaPorColhedor />} />
    <Route path="/recibos" element={<Recibos />} />
    <Route path="/radiantamentos" element={<RAdiantamento />} />
    <Route path="/" element={<Paginainicial />} />
    {/* <Route path="*" element={<Paginainicial />} /> */}
   </Routes>
  );
};